import { APP_TENANT } from "../constants/app-url"

export const isValidToken = (
  token: string | undefined | null
): token is string =>
  !!token && token !== "null" && token !== "undefined" && token !== ""

export const getCookieValue = (cookieName: string): string | undefined => {
  const cookies = document.cookie.split(";")
  // startsWith on the trimmed "name=" prevents substring collisions:
  // .includes() let tenant "acme." match cookie "supportacme.cookie.oidc.auth"
  // (real during emulation, where both tenants' cookies coexist).
  const cookie = cookies.find((a) =>
    a.trim().startsWith(`${APP_TENANT}cookie.${cookieName}=`)
  )
  // join("=") keeps values that themselves contain "=" (base64 padding)
  return cookie?.split("=").slice(1).join("=")
}

export const clearCookie = (key: string, domain = "") => {
  const samesite = isAuthCookie(key) ? "SameSite=None; Secure; " : ""
  document.cookie = `${APP_TENANT}cookie.${key}=; Path=/; ${samesite}Expires=Thu, 01 Jan 1970 00:00:01 GMT; Domain=${domain}`
}

export const setCookie = (
  key: string,
  val: string,
  expiry: string | null = null,
  domain = ""
) => {
  const expiryStr = expiry ? `Expires=${expiry};` : ""
  const samesite = isAuthCookie(key) ? "SameSite=None; Secure; " : ""
  document.cookie = `${APP_TENANT}cookie.${key}=${val}; Path=/; ${samesite}${expiryStr} Domain=${domain}`
}

const isAuthCookie = (key: string): boolean => {
  return key === "oidc.auth" || key === "oidc.id_token"
}

export const getSessionInterval = (decodedUserToken: any): number => {
  const expiryDate = new Date(decodedUserToken.expiry).getTime()
  const currentTime = new Date().getTime()
  return expiryDate - currentTime
}
